import './radios.scss';
import React, { Component } from 'react';
import RibbonsUtil from '../../utils/RibbonsUtil';
import store from '../../store';
import Translator from './../../requests/apa/Translator';
import { SHOW_MODAL, MODAL_COUNTRIES_FILTER } from '../../actions/modal';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

class CountriesFilter extends Component {
    constructor(props) {
        super(props);
        this.modal = {
            type: SHOW_MODAL,
            modalType: MODAL_COUNTRIES_FILTER
        };
        this.state = {
            user: props.user,
            menuItems: [],
            country: {
                name: '',
                code: ''
            },
            countryDefault: Translator.get('COUNTRIES', 'PAISES'),
            countriesFilterIsOpen: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { user } = this.props;
        if (nextProps.user !== undefined && nextProps.user !== user) {
            this.getCountries(nextProps.user);
        }
    }

    componentDidMount() {
        const { user } = this.props;
        if (user !== undefined) {
            this.getCountries(user);
        }
        window.SpatialNavigation.makeFocusable();
    }
    getCountries(user) {
        const musicRb = new RibbonsUtil();
        musicRb
            .getRadiosApi('countries', user, {})
            .then(resp => {
                const { countries } = resp.response;
                const country = countries.find(c => c.code === user.countryCode);
                this.setState({ menuItems: countries, countryDefault: country.name.toUpperCase() });
            })
            .catch(error => {
                logger.error('Fail to get countries filter will not show: ' + error);
            });
    }

    toggleListCountryFilter() {
        const { countriesFilterIsOpen, menuItems } = this.state;
        if (!countriesFilterIsOpen) {
            this.modal.modalProps = {
                setCountryTitle: country => this.setCountryTitle(country),
                onSelectFilter: country => this.props.onSelectFilter(country),
                toggleListCountryFilter: () => this.toggleListCountryFilter(),
                menuItems: menuItems
            };
            store.dispatch(this.modal);
        }
        this.setState(prevState => {
            return { countriesFilterIsOpen: !prevState.countriesFilterIsOpen };
        });
    }

    setCountryTitle(country) {
        this.setState({ country: country });
    }

    handleMouseEnter = (e) => {
        Utils.handleMouseEnter(e)
    }

    render() {
        const { title } = this.props;
        const { countriesFilterIsOpen, countryDefault } = this.state;
        return (
            <div className="country-filter">
                <nav className="nav_interno_2 filter2_1p">
                    <ul>
                        <li
                            className="focus-selector"
                            onClick={e => {
                                e.stopPropagation();
                                this.toggleListCountryFilter();
                            }}
                        >
                            <a
                                id={String(`keyCMR-${Math.floor(10000 + Math.random() * 90000)}`)}
                                className={`focusable`}
                                href="#"
                                onClick={e => {
                                    e.stopPropagation();
                                    this.toggleListCountryFilter();
                                }}
                                onMouseEnter={e => {
                                    this.handleMouseEnter(e);
                                }}
                            >
                                <span>{title === '' ? countryDefault : title.toUpperCase()}</span>
                                <i
                                    className={`${
                                        countriesFilterIsOpen
                                            ? 'fa fa-angle-down rotate2 down'
                                            : 'fa fa-angle-down rotate2'
                                    }`}
                                />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }
}

export default CountriesFilter;



// WEBPACK FOOTER //
// ./src/containers/Radios/countriesFilter.jsx